import React, { useRef, useState, useEffect, useContext } from "react";

import {
    UiCol,
    UiRowContainer,
    UiSingleRow,
} from "../../../grid-container/GridContainer";

import FooterLogo from "../../../../../styles/img/sherbet-footer-logo.png";
import { UiButtonPrimary } from "../../../form/UiButton";
import FooterFbIcon from "../../../../../styles/img/svg/FooterFbIcon";
// import FooterLinkedinIcon from "../../../../styles/img/svg/FooterLinkedinIcon";
// import FooterTwitterIcon from "../../../../styles/img/svg/FooterTwitter";
import {
    UiFooterLeftCol,
    UiFooterEmailSubscribe,
    UiFooterContacts,
    UiFooterSocialMedia,
    UiFooterCopyRights,
    UiFooterNavWr,
    UiFooterNavTitle,
    UiFooterNavItem,
    UiFooterTop,
} from "./UiFooterElements";
import UiFooterWr from "./UiFooterElements";
import Logo from "../../../../../styles/img/custom/renault-footer-logo.png";
import { YoutubeIcon } from "../../../../../styles/img/svg/YoutubeIcon";
import { TwitterIcon } from "../../../../../styles/img/svg/TwitterIcon";
import { VimeoIcon } from "../../../../../styles/img/svg/VimeoIcon";
import PowerdByLogo from "../../../../../styles/img/custom/powered-by-logo.png";
import UiCustomWr from "../UiCustomWr";
import { UiModal } from "../../../../_uiComponents/common/UiModal";
import { Context } from "../../../../../_context/Store";
import RulesAndTermsModal from "../../../../pages/auth/RulesAndTermsModal";
import UiChatBot from "../../../chat-bot/UiChatBot";
import CahtBotIcon from "../../../../../styles/img/svg/ChatBotIcon";
import CloseBlackIcon from "../../../../../styles/img/svg/CloseBlackIcon";
import { useDispatch, useSelector } from "react-redux";
import { subscribeRequest } from "../../../../../_redux/_actions";
import {
    participantJobRoleIds,
    participantTypeIds,
    roleId,
} from "../../../../../_redux/_constants";

import AiChatWithModel from "../../../../pages/insight/AiChatWithModel";

export default function CustomFooter(props) {
    const actionDispatch = useDispatch();
    const { userProfileDetails } = useSelector((state) => {
        return {
            userProfileDetails: state.auth.userProfileDetails,
        };
    });

    const [isVisible, setIsVisible] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [susbscribe, setSubscribe] = useState(false);
    const [state, dispatch] = useContext(Context);

    useEffect(() => {
        setSubscribe(userProfileDetails?.rewardUpdatesSubscribed);
    }, [userProfileDetails]);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };
    const handleHideModal = () => {
        setShowModal(false);
    };
    const handleShowModal = () => {
        setShowModal(true);
    };
    const showTermsModal = () => {
        dispatch({
            type: "LARGE_MODAL",
            payload: {
                show: true,
                title: "Rules & Terms of Use",
                subTitle: "",
                children: <RulesAndTermsModal />,
            },
        });
    };

    const showChatBox = () => {
        // dispatch({
        //     type: "CHAT_BOX_MODAL",
        //     payload: {
        //         show: true,
        //         children:  <UiChatBot/>,
        //     },
        // });
        dispatch({
            type: "FOOTER_CONTENT_MODAL",
            payload: {
                show: true,
                children: (
                    <>
                        <h3 className="sb-chat-support-content">
                            Got a question or need help to get you up and
                            running?
                        </h3>
                        {userProfileDetails.roleId ==
                        participantTypeIds.PARTICIPANT ? (
                            <h6 className="sb-chat-support-content-email">
                                Message us at: support@rgequipe.com{" "}
                            </h6>
                        ) : (
                            <h6 className="sb-chat-support-content-email">
                                {userProfileDetails?.jobRoleId ==
                                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_EQUIPE_CUSTOMER ||
                                userProfileDetails?.jobRoleId ==
                                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_GROUP_PARTS_MANAGER ||
                                userProfileDetails?.jobRoleId ==
                                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_EXECUTIVE ||
                                userProfileDetails?.jobRoleId ==
                                    participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_MANAGER
                                    ? "Message us at: Support@MyRGRewards.com"
                                    : "Message us at: support@renaultTLC.com"}
                            </h6>
                        )}
                    </>
                ),
            },
        });
    };

    const showSupportModal = () => {
        dispatch({
            type: "FOOTER_CONTENT_MODAL",
            payload: {
                show: true,
                children: (
                    <>
                        <>
                            {userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_EQUIPE_CUSTOMER ||
                            userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_GROUP_PARTS_MANAGER ||
                            userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_EXECUTIVE ||
                            userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_MANAGER ? (
                                <>
                                    <h3>RG Rewards Support</h3>
                                    <h5 className="sb-footer-support-content">
                                        For Campaign support message us at:
                                        support@myrgrewards.com
                                    </h5>
                                </>
                            ) : userProfileDetails.roleId ==
                              participantTypeIds.TLC_PARTICIPANT ? (
                                <>
                                    <h3>TLC Support</h3>
                                    <h5 className="sb-footer-support-content">
                                        For Campaign support message us at:
                                        support@renaultTLC.com
                                    </h5>
                                </>
                            ) : (
                                <>
                                    <h3>Équipe Support</h3>
                                    <h5 className="sb-footer-support-content">
                                        For Campaign support message us at:
                                        support@rgequipe.com
                                    </h5>
                                </>
                            )}
                        </>
                    </>
                ),
            },
        });
    };

    const showMessage = () => {
        setSubscribe(!susbscribe);
        if (!susbscribe) {
            dispatch({
                type: "FOOTER_CONTENT_MODAL",
                payload: {
                    show: true,
                    children: (
                        <>
                            <h3>Thanks for subscribing</h3>
                        </>
                    ),
                },
            });
        } else {
            dispatch({
                type: "FOOTER_CONTENT_MODAL",
                payload: {
                    show: true,
                    children: (
                        <>
                            <h3>You have been unsubscribed</h3>
                        </>
                    ),
                },
            });
        }
    };

    const handleSubscribe = () => {
        actionDispatch(
            subscribeRequest({
                subscribe: !susbscribe,
                showMessage,
            }),
        );
    };

    useEffect(() => {
        const toggleVisibility = () => {
            if (window.pageYOffset > 1500) {
                setIsVisible(true);
            } else {
                setIsVisible(false);
            }
        };

        window.addEventListener("scroll", toggleVisibility);

        return () => window.removeEventListener("scroll", toggleVisibility);
    }, []);

    const elementRef = useRef();

    // Open chat window
    const openChatWindow = () => {
        dispatch({
            type: "SIDE_PANEL",
            payload: {
                show: true,
                title: "",
                children: <AiChatWithModel />,
            },
        });
    };

    return (
        <>
            {isVisible && (
                <div onClick={scrollToTop} className="sb-scroll-to-top">
                    &#8593;
                </div>
            )}

            {userProfileDetails?.jobRoleId ===
                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_NATIONAL_MANAGER &&
                [1000001, 2000035, 2000588, 2000038].includes(
                    userProfileDetails?.userId,
                ) && (
                <div className="sb-chat-box-fixed-label">
                    <span onClick={openChatWindow}>
                        {" "}
                        <CahtBotIcon />
                    </span>
                    {/* {state.ui_chat_box.show === true ? <span onClick={hideChatBox}><CloseBlackIcon/></span> : <span onClick={showChatBox}> <CahtBotIcon/></span>  }  */}
                </div>
            )}
            <UiCustomWr>
                <UiFooterTop />
                <UiFooterWr ref={elementRef}>
                    <UiRowContainer>
                        <div className="sb-footer-subscribe">
                            {userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_EQUIPE_CUSTOMER ||
                            userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_GROUP_PARTS_MANAGER ||
                            userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_EXECUTIVE ||
                            userProfileDetails?.jobRoleId ==
                                participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_MANAGER ? (
                                <h4>
                                    Sign up for exclusive Renault reward updates
                                </h4>
                            ) : userProfileDetails.roleId ==
                              participantTypeIds.TLC_PARTICIPANT ? (
                                <h4>
                                    Sign up for exclusive TLC reward updates
                                </h4>
                            ) : (
                                <h4>
                                    Sign up for exclusive ÉQUIPE reward updates
                                </h4>
                            )}

                            <UiFooterEmailSubscribe>
                                <UiButtonPrimary
                                    btnName={
                                        susbscribe
                                            ? "Unsubscribe"
                                            : "Subscribe Now"
                                    }
                                    size="56"
                                    onClick={handleSubscribe}
                                />
                            </UiFooterEmailSubscribe>
                        </div>
                    </UiRowContainer>

                    <UiRowContainer className="sb-footer-content-wr">
                        {/* <div className="sb-footer-logo">
                            <img src={Logo} />
                        </div> */}
                        <div className="sb-footer-bottom-section">
                            <div className="sb-footer-bottom-section__left">
                                <span onClick={showTermsModal}>
                                    Rules & Terms{" "}
                                </span>
                                <span onClick={showSupportModal}>
                                    {userProfileDetails?.jobRoleId ==
                                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_EQUIPE_CUSTOMER ||
                                    userProfileDetails?.jobRoleId ==
                                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_GROUP_PARTS_MANAGER ||
                                    userProfileDetails?.jobRoleId ==
                                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_EXECUTIVE ||
                                    userProfileDetails?.jobRoleId ==
                                        participantJobRoleIds.PARTICIPANT_JOB_ROLE_ID_SALES_MANAGER
                                        ? "RG Rewards Support"
                                        : userProfileDetails.roleId ==
                                          participantTypeIds.TLC_PARTICIPANT
                                        ? "TLC Support"
                                        : "Équipe Support"}
                                </span>
                            </div>
                            <div className="sb-footer-bottom-section__right">
                                <img src={PowerdByLogo} />
                            </div>
                        </div>
                    </UiRowContainer>
                </UiFooterWr>
            </UiCustomWr>
        </>
    );
}
